<template>
	<div class="lang-nav">
		<nuxt-link v-for="item in items" :key="item.filename" :class="item.language" :to="item.filename">
			<span>{{ item.language }}</span> <span class="dot">|</span>
		</nuxt-link>
	</div>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.lang-nav {
	position: absolute;
	inset: 60px auto auto 30px;

	a {
		text-decoration: none;
		font-weight: 300;
		font-family: var(--body-font-family);
		font-size: 20px;
		letter-spacing: 1px;
		font-style: italic;
		text-transform: uppercase;
		color: var(--primary-background-color);

		span:not(.dot) {
			border-bottom: 2px solid rgb(0 0 0 / 0%);
			padding: 0 0 0 3px;
		}

		&.router-link-exact-active {
			span {
				border-color: var(--primary-background-color);
			}
		}

		.dot {
			margin: 0 8px 0 4px;
		}

		&:last-child {
			.dot {
				display: none;
			}
		}
	}
}
</style>
